import React, { useLayoutEffect, useRef, useState } from "react";
import "./Question.css";
import { IQuestion, QuestionType } from "src/network/fetchApplicationQuestions";
import { useIsMobile } from "src/hooks/useIsMobile";

interface Props {
  question: IQuestion;
  handleAnswerChange: (questionNumber: string, value: string) => void;
}

const LINE_CHARS = 150;
const COMPONENT_MAX_WIDTH = 800;

function ForumInputComponent({
  question: questionItem,
  handleAnswerChange,
}: Props) {
  const { question, question_type, question_number, required } = questionItem;
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { isMobile, screenWidth } = useIsMobile();
  const [isFocused, setIsFocused] = useState(false); // Track focus state

  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (textarea && question.ar && question.en) {
      const numberOfEnglishLines = Math.ceil(
        (question.en?.length ?? 1) / LINE_CHARS
      );
      const numberOfArabicLines = Math.ceil(
        (question.ar?.length ?? 1) / LINE_CHARS
      );
      let numberOfLines = numberOfArabicLines + numberOfEnglishLines;
      if (isMobile) {
        numberOfLines *= COMPONENT_MAX_WIDTH / screenWidth;
      }

      textarea.style.height = "auto"; // Reset height to auto to calculate the scroll height
      textarea.style.height = `${numberOfLines * 25}px`; // Set height based on scroll height
    }
  }, [isMobile, question.ar, question.en, screenWidth]);

  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    const value = event.target.value;
    handleAnswerChange(question_number, value);
  }

  const placeholderText = `${question.en} ${required && "*"}\n${question.ar}`;

  if (question_type === QuestionType.Text) {
    return (
      <div className="input-wrapper">
        {isFocused && <div className="tooltip">{placeholderText}</div>}
        <textarea
          ref={textareaRef}
          className="text-input"
          placeholder={isFocused ? "" : placeholderText} // Hide placeholder when focused
          rows={4}
          style={{
            overflow: "hidden",
            resize: "none",
          }}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)} // Show tooltip on focus
          onBlur={() => setIsFocused(false)} // Hide tooltip on blur
        />
      </div>
    );
  }

  return (
    <div className="input-wrapper">
      {isFocused && <div className="tooltip">{question.en}</div>}
      <input
        className="text-area"
        placeholder={isFocused ? "" : question.en} // Hide placeholder when focused
        onChange={(e) => handleAnswerChange(question_number, e.target.value)}
        onFocus={() => setIsFocused(true)} // Show tooltip on focus
        onBlur={() => setIsFocused(false)} // Hide tooltip on blur
      />
    </div>
  );
}

export default ForumInputComponent;
